import React from 'react';
import { Formik, Form as FormikForm, FastField } from 'formik';
import { Button, FormGroup, Label } from 'reactstrap';
import { atualizacaoTituloFiltroSchema } from '../validation/atualizacaoTitulo.filters';
import { DateTimePicker, Input } from '../../../shared';
import { formatarDocumento } from '../../../utils/documentoAlfanumerico';
import '../styles.scss';

const DocumentoFiltroInput = ({ field, form, label, ...props }) => {
  const fieldFormatado = {
    ...field,
    value: formatarDocumento(field.value),
    onChange: event => {
      form.setFieldValue(field.name, formatarDocumento(event.target.value));
    }
  };

  return <Input field={fieldFormatado} form={form} label={label} {...props} />;
};

const AtualizacaoTituloFiltros = ({
  collapsed,
  clienteAtual,
  filtrosAplicados,
  onApply,
  onClear,
  onClose
}) => {
  if (collapsed) return null;

  const handleSubmit = async (values, actions) => {
    if (onApply) {
      await onApply(values);
    }

    if (actions && typeof actions.setSubmitting === 'function') {
      actions.setSubmitting(false);
    }
  };

  return (
    <div className="at-layout__filters">
      <Formik
        enableReinitialize
        initialValues={filtrosAplicados}
        validationSchema={atualizacaoTituloFiltroSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, isSubmitting, resetForm, submitForm }) => (
          <FormikForm>
            <div className="at-filters">
              <div
                className="at-filters__header"
                onClick={() => (onClose ? onClose() : null)}
                onKeyPress={() => (onClose ? onClose() : null)}
                role="button"
                tabIndex={0}
                aria-label="Fechar filtros"
              >
                <h4 className="at-filters__title">
                  Filtros
                  <i className="fa fa-angle-right float-right" />
                </h4>
              </div>
              <div className="at-filter-divider" />

              <div className="at-filters__body">
                <div className="container p-0">
                  <FormGroup>
                    <Label>Cliente</Label>
                    <p className="at-static">
                      {clienteAtual && (clienteAtual.razaoSocial || clienteAtual.nomeFantasia)}
                    </p>
                  </FormGroup>

                  <div className="at-filter-group">
                    <Label>Data de processamento (de/até)</Label>

                    <div className="at-filter-pair">
                      <div className="at-filter-pair__item">
                        <FastField
                          name="data_inicio"
                          id="start"
                          disableWeekend={false}
                          disabled={isSubmitting}
                          component={DateTimePicker}
                          autoComplete="off"
                        />
                        {touched.data_inicio && errors.data_inicio && (
                          <div className="at-filter-error">{errors.data_inicio}</div>
                        )}
                      </div>

                      <div className="at-filter-pair__item">
                        <FastField
                          name="data_final"
                          id="end"
                          disableWeekend={false}
                          disabled={isSubmitting}
                          component={DateTimePicker}
                          autoComplete="off"
                        />
                        {touched.data_final && errors.data_final && (
                          <div className="at-filter-error">{errors.data_final}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="at-filter-group">
                    <Label>Valor do título (entre)</Label>

                    <div className="at-filter-pair">
                      <div className="at-filter-pair__item">
                        <FastField
                          type="text"
                          name="valor_min"
                          id="valor_min"
                          disabled={isSubmitting}
                          component={Input}
                          placeholder="Valor mínimo"
                          autoComplete="off"
                        />
                        {touched.valor_min && errors.valor_min && (
                          <div className="at-filter-error">{errors.valor_min}</div>
                        )}
                      </div>

                      <div className="at-filter-pair__item">
                        <FastField
                          type="text"
                          name="valor_max"
                          id="valor_max"
                          disabled={isSubmitting}
                          component={Input}
                          placeholder="Valor máximo"
                          autoComplete="off"
                        />
                        {touched.valor_max && errors.valor_max && (
                          <div className="at-filter-error">{errors.valor_max}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="at-filter-group">
                    <FastField
                      type="text"
                      label="CPF/CNPJ do sacado"
                      name="cpfcnpj_sacado"
                      id="cpfcnpj_sacado"
                      uppercase
                      disabled={isSubmitting}
                      component={DocumentoFiltroInput}
                      placeholder="CPF/CNPJ do sacado"
                      autoComplete="off"
                    />
                    {touched.cpfcnpj_sacado && errors.cpfcnpj_sacado && (
                      <div className="at-filter-error">{errors.cpfcnpj_sacado}</div>
                    )}
                  </div>

                  <div className="at-filter-group">
                    <FastField
                      type="text"
                      label="Nome do sacado"
                      name="nome_sacado"
                      id="nome_sacado"
                      disabled={isSubmitting}
                      component={Input}
                      placeholder="Nome do sacado"
                      autoComplete="off"
                    />
                    {touched.nome_sacado && errors.nome_sacado && (
                      <div className="at-filter-error">{errors.nome_sacado}</div>
                    )}
                  </div>

                  <div className="at-filter-group">
                    <Label>Vencimento (entre)</Label>

                    <div className="at-filter-pair">
                      <div className="at-filter-pair__item">
                        <FastField
                          type="text"
                          name="vencimento_inicio"
                          id="vencimento_inicio"
                          disabled={isSubmitting}
                          component={DateTimePicker}
                          placeholder="DD/MM/AAAA"
                          autoComplete="off"
                        />
                        {touched.vencimento_inicio && errors.vencimento_inicio && (
                          <div className="at-filter-error">{errors.vencimento_inicio}</div>
                        )}
                      </div>

                      <div className="at-filter-pair__item">
                        <FastField
                          type="text"
                          name="vencimento_final"
                          id="vencimento_final"
                          disabled={isSubmitting}
                          component={DateTimePicker}
                          placeholder="DD/MM/AAAA"
                          autoComplete="off"
                        />
                        {touched.vencimento_final && errors.vencimento_final && (
                          <div className="at-filter-error">{errors.vencimento_final}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="at-filter-group">
                    <FastField
                      type="text"
                      label="Número do documento"
                      name="ndoc"
                      id="ndoc"
                      disabled={isSubmitting}
                      component={Input}
                      placeholder="Número do documento"
                      autoComplete="off"
                    />
                    {touched.ndoc && errors.ndoc && <div className="at-filter-error">{errors.ndoc}</div>}
                  </div>

                  <div className="at-filter-group">
                    <FastField
                      type="text"
                      label="Número do borderô"
                      name="bordero"
                      id="bordero"
                      disabled={isSubmitting}
                      component={Input}
                      placeholder="Número do borderô"
                      autoComplete="off"
                    />
                    {touched.bordero && errors.bordero && (
                      <div className="at-filter-error">{errors.bordero}</div>
                    )}
                  </div>
                </div>
              </div>

              <div className="at-filter-divider" />
              <div className="at-filter-actions">
                <Button
                  type="button"
                  outline
                  color="primary"
                  className="at-filter-btn-clear"
                  disabled={isSubmitting}
                  onClick={async () => {
                    resetForm({ values: filtrosAplicados });
                    if (onClear) {
                      await onClear();
                    }
                  }}
                >
                  Limpar
                </Button>

                <Button
                  type="button"
                  color="primary"
                  className="at-filter-btn-apply"
                  disabled={isSubmitting}
                  onClick={submitForm}
                >
                  Filtrar
                </Button>
              </div>
            </div>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default AtualizacaoTituloFiltros;
